import { getMonth, max, min } from 'date-fns'
import { getDatesRange, getDatesDiff } from '@/utils/date'

export const GPR_STATUSES = {
  IN_WORK: 'in_work',
  IN_QUEUE: 'in_queue',
  EXPIRED: 'expired',
  DEVIATION: 'deviation',
  FINISHED: 'finished'
}

export const DEFAULT_UNITS = [
  {
    short_name: 'д',
    full_name: 'дни'
  },
  {
    short_name: 'м',
    full_name: 'метры'
  },
  {
    short_name: 'м²',
    full_name: 'квадратные метры'
  },
  {
    short_name: 'м³',
    full_name: 'кубические метры'
  },
  {
    short_name: 'т',
    full_name: 'тонны'
  },
  {
    short_name: 'шт',
    full_name: 'штуки'
  }
]

export const createYearRange = data => {
  let preparedDates = data.map(({start_at_gpr_jobs, end_at_gpr_jobs, expect_end_at_gpr_jobs}) => {
    if (start_at_gpr_jobs && end_at_gpr_jobs) {
      const endAt = expect_end_at_gpr_jobs && isDateLater(end_at_gpr_jobs, expect_end_at_gpr_jobs)
        ? expect_end_at_gpr_jobs
        : end_at_gpr_jobs;
      return [new Date(start_at_gpr_jobs), new Date(endAt)];
    }
  }).flat(1);
  let currentDate = new Date()
  
  let maxDate = max(preparedDates)
  let minDate = min(preparedDates)
  let datesDiffFromMinDate = getDatesDiff([minDate, currentDate], 'days')
  let datesDiff = getDatesDiff([minDate, maxDate], 'years')
  let datesRange = getDatesRange(minDate, maxDate).map(value => parseInt(value, 10))

  return {
    maxDate,
    minDate,
    datesDiff,
    datesRange,
    datesDiffFromMinDate
  }
}

export const isDateLater = (firstDate, secondDate, type='days') => {
  const dateDiff = getDatesDiff([firstDate, secondDate], type);
  return dateDiff > 0;
}

export const isDateEarlier = (firstDate, secondDate, type='days') => {
  const dateDiff = getDatesDiff([firstDate, secondDate], type);
  return dateDiff < 0;
}

export const calcDatesDiff = (dates, type = 'days') => {
  switch(type) {
  case 'month':
    return defineMonthDiff(dates);
  case 'days':
    return getDatesDiff(dates, 'days');
  default:
    return getDatesDiff(dates, 'days');
  }
}

export const defineMonthDiff = dates => {
  let monthDiff = getDatesDiff(dates, 'months')
  if (monthDiff === 1) {
    const daysDiff = getDatesDiff(dates, 'days')
    monthDiff = daysDiff > 15 ? getDatesDiff(dates, 'months') : getDatesDiff(dates, 'months') * 0.5;
  }
  return monthDiff;
}

export const calcTimeLineOffset = (date, cellWidth, type = 'month') => {
  let offsetStep = cellWidth / 6;
  let coefficient = 1;
  if (type === 'days') {
    offsetStep = cellWidth / 6 / 30;
    coefficient = 30;
  }
  /*
   Month - 1 потому что на интересует отступ, не включая текующий месяц!
   */
  let month = getMonth(new Date(date)) - 1;

  return (month < 6 ? (month) * offsetStep : (month - 6) * offsetStep) * coefficient;
}
